import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import ProduttivoMuiTheme from '../components/shared/themes/ProduttivoTheme';
import FiltersContainer from './presentation/pages/form_fills/FiltersContainer';

const formFillsFiltersErb = document.getElementById('formFills-container');

if (formFillsFiltersErb != null) {

  const root = createRoot(formFillsFiltersErb);
  root.render(
    <ThemeProvider theme={ProduttivoMuiTheme}>
      <FiltersContainer 
        accountId={window.currentAccountId} 
        dateFilterRange={window._filteredRangeTime || undefined}  
      />
    </ThemeProvider>
  );
}